import "./OurApproach.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import OurEthicalFramework from "./sections/OurEthicalFramework";
import ConfidentialityGuaranteed from "./sections/ConfidentialityGuaranteed";
import Footer from "@/reusable_sections/Footer";
export default function OurApproachPage() {
  return <div>
      <Header />
      <HeroSection />
      <OurEthicalFramework />
      <ConfidentialityGuaranteed />
      <Footer />
    </div>;
}